import React from "react";

const LeBonTechnicien2grid = ({ title, subtitle, paragraph, imgSrc }) => {
  return (
    <section className="aventage-client">
      <div className="container aventage-client-container">
        <div className="column">
          <h2 className="leBonTech-h2">{title}</h2>
          {subtitle && <p className=" leBonTech-p p-accroche">{subtitle}</p>}
          <p className="leBonTech-p">{paragraph}</p>
        </div>
        <div className="column">
          <div className="aventage-client-image-container">
            <img src={imgSrc} alt={subtitle} className="image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeBonTechnicien2grid;
